'use client';

import { useState } from 'react';
import dynamic from 'next/dynamic';
import AuthDrawerSkeleton from '../auth-drawer-skeleton';
import type { SignInDrawerProps } from './types';

// Re-export so sibling triggers (sign-in-trigger, account-nav-button) keep their
// `import { SIGN_IN_DRAWER_ID } from '../sign-in-drawer'` working.
export { SIGN_IN_DRAWER_ID } from './constants';

// EWM-306: lazy-load the drawer body so it stays out of the critical bundle
// until the user first opens an auth drawer.
const SignInDrawerContent = dynamic(() => import('./components/sign-in-drawer-content'), {
  ssr: false,
  loading: () => <AuthDrawerSkeleton headlineKey="auth.sign-in-title" />,
});

const SignInDrawer = (props: SignInDrawerProps) => {
  // Latch: the provider always renders this drawer (toggling isOpen), so a naive
  // dynamic() would fetch the chunk on page load. Render nothing until the first
  // open; once opened, stay mounted so the close animation plays and re-opens
  // need no second fetch.
  const [hasOpened, setHasOpened] = useState(false);
  if (props.isOpen && !hasOpened) setHasOpened(true);
  if (!hasOpened) return null;

  return <SignInDrawerContent {...props} />;
};

export default SignInDrawer;
